import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, List, ListItemText, Radio, FormControlLabel, ListItemButton } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';

const progress = 0; 
const step = 3; 

type PublishOutletContext = {
  handleNavigateToPropertyHunter: () => void;
  propertyVisibility: string;
  setPropertyVisibility: (propertyVisibility: string) => void;
};

const PropertyVisibilityPage: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const navigate = useNavigate();
  const { handleNavigateToPropertyHunter, propertyVisibility, setPropertyVisibility } = useOutletContext<PublishOutletContext>();

  useEffect(() => {
    setSelectedOption(propertyVisibility);
  }, [propertyVisibility]);

  const handleSelection = (option: string) => {
    setSelectedOption(option);
    setPropertyVisibility(option);
  };

  const handleBack = () => {
    navigate(-1); 
  };

  const handleContinue = () => {
    handleNavigateToPropertyHunter();
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', pb: 12, flexDirection: 'column', alignItems: 'center' }}>
      <Box p={4} sx={{ width: '80%' }}>
        <Typography variant="h4" gutterBottom mb={2}>
          Elige quién puede ver tu publicación en el muro
        </Typography>
        <Typography variant="body1" mb={4}>
          Decide si tu publicación será visible para todos los usuarios o solo para usuarios registrados.
        </Typography>

        <List sx={{ width: '100%' }}>
          {/* Opción de visibilidad pública */}
          <ListItemButton
            onClick={() => handleSelection('Pública')}
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              border: selectedOption === 'Pública' ? '2px solid black' : '1px solid grey',
              transition: 'border 0.3s',
              cursor: 'pointer',
            }}
          >
            <FormControlLabel
              control={
                <Radio
                  checked={selectedOption === 'Pública'}
                  value="Pública"
                  color="success"
                />
              }
              label={
                <ListItemText
                  primary="Visible para todos los usuarios"
                  secondary="Tu publicación será visible para todos los usuarios de Alien Realty, lo que puede aumentar la rapidez con la que recibes solicitudes."
                  primaryTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                  secondaryTypographyProps={{ variant: 'body2', mt: 1 }}
                />
              }
              sx={{ width: '100%' }}
            />
          </ListItemButton>

          {/* Opción de visibilidad solo para usuarios registrados */}
          <ListItemButton
            onClick={() => handleSelection('Privada')}
            sx={{
              p: 2,
              borderRadius: 2,
              border: selectedOption === 'Privada' ? '2px solid black' : '1px solid grey',
              transition: 'border 0.3s',
              cursor: 'pointer',
            }}
          >
            <FormControlLabel
              control={
                <Radio
                  checked={selectedOption === 'Privada'}
                  value="Privada"
                  color="success"
                />
              }
              label={
                <ListItemText
                  primary="Visible solo para usuarios registrados"
                  secondary="Tu publicación será visible solo para usuarios que estén registrados en Alien Realty."
                  primaryTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                  secondaryTypographyProps={{ variant: 'body2', mt: 1 }}
                />
              }
              sx={{ width: '100%' }}
            />
          </ListItemButton>
        </List>
      </Box>

      <PropertyFooterLayout
        progress={progress}
        step={step}
        onBack={handleBack}
        onContinue={handleContinue}
        isContinueDisabled={!selectedOption}
      />
    </Container>
  );
};

export default PropertyVisibilityPage;
